import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { FavoriteCardTypeEnum, UserFavoriteCardData } from '../../../user-favorite-data.model';

@Component({
  selector: 'favorite-card-content',
  template: `
    <div class="offer-card-content {{data.product.toLowerCase()}} {{cardType}}" [ngClass]="{'-eva-3-pb-lg': data.product === 'FLIGHT'}">

      <div *ngIf="data.product_text && showProductName" class="offer-card-product">{{data.product_text}}</div>
      <div class="offer-card-title favorite-card-title -eva-3-ellipsis">{{data.main_text}}</div>

      <div *ngIf="data.auxiliary_text && cardType !== 'REDUCED'" class="offer-card-description favorite-card-description">{{data.auxiliary_text}}</div>

      <div *ngIf="data.overall_rating || data.stars" class="offer-card-rating favorite-card-rating">
        <div *ngIf="data.overall_rating" class="eva-3-rating -good -sm">
          <span class="rating-text">{{data.overall_rating}}</span>
        </div>
        <div *ngIf="data.overall_rating_text">
            <span class="overall-rating-text">{{ data.overall_rating_text }}</span>
        </div>
        <div *ngIf="data.stars" class="offer-card-rating-stars">
          <i *ngFor="let star of stars" class="-eva-3-icon-xsm eva-3-icon-star"></i>
        </div>
      </div>
      <div *ngIf="data.auxiliary_text && cardType === 'REDUCED'" class="offer-card-description favorite-card-description">{{data.auxiliary_text}}</div>

    </div>
  `,
  styleUrls: ['./favorite-card-content.component.scss'],
})
export class FavoriteCardContentComponent implements OnInit {
  @Input() data: UserFavoriteCardData;
  @Input() showProductName = true;
  @Input() cardType: FavoriteCardTypeEnum;

  stars: Array<any> = [];

  ngOnInit(): void {
    this.initStars();
    this.initDrivers();
  }

  private initStars(): void {
    if (this.data.stars) {
      this.stars = new Array(Number(this.data.stars)).fill({});
    }
  }

  private initDrivers(): void {
    this.data.drivers = this.cardType === 'REDUCED' && this.data.product == 'ACTIVITY' ? [] : this.data.drivers;
  }

}
